import { formatNumber } from '@angular/common';
import { Component, Inject, Input ,LOCALE_ID,OnInit } from '@angular/core';

@Component({
  selector: 'app-stats-item',
  templateUrl: './stats-item.component.html',
  styleUrls: ['./stats-item.component.scss']
})
export class StatsItemComponent implements OnInit{

  @Input() iconName: any;
  @Input() authorizedValue: any;
  @Input() onTheMarketValue: any;
  @Input() title: any;
  @Input() link:any;
  value:string="0";
  constructor(
    @Inject(LOCALE_ID) public locale: string
  ){
    
  }
  ngOnInit(): void {
    this.value =formatNumber(this.authorizedValue as number,this.locale)
  }
}
